var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-form-container"},[(_vm.internalLoading)?_c('internal-loading'):_vm._e(),_c('div',{staticClass:"auth-form",attrs:{"id":"form-builder"}}),_c('el-button',{staticClass:"auth-button",on:{"click":_vm.onSubmit}},[_vm._v("AVANÇAR")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }